import seal from './Worker/seal.worker'
import WorkerAdapter from './Adapter'
export default new WorkerAdapter(seal)
